import ViewAll from './ViewAll'

export default ViewAll
// eslint-disable-next-line import/export
export * from './ViewAll'
